import {inject, Pipe, PipeTransform} from '@angular/core';
import {config} from "../../config";
import {AppService} from "../services/app.service";

/** `url` with the chosen insurer and plan as main-site bridging params. Unchanged until an insurer is chosen. */
export function appendAppStateParams(url: string, insurance: ReturnType<AppService['data']>['insurance']): string {
  const insuranceId = insurance?.primary?.id;
  const planId = insurance?.primary?.planId;

  if (!insuranceId) {
    return url;
  }
  if (url.includes('?')) {
    url += '&'
  } else {
    url += '?'
  }
  return `${url}${config.mainSiteBridging.paramNames.insuranceId}=${insuranceId}&${config.mainSiteBridging.paramNames.planId}=${planId}`;
}

@Pipe({
  name: 'appendAppStateParams'
})
export class AppendAppStateParamsPipe implements PipeTransform {

  app = inject(AppService);
  transform(value: string): string {
    return appendAppStateParams(value, this.app.data().insurance);
  }

}
